PJQ.views.settings.DailyReportSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Daily-Reports')
    },
    events: {},
    beforeFirstRender: function () {
    },
    beforeRender: function () {
    },
    afterRender: function () {

    }
});
